__turbopack_context__.v({
  "contentWraper": "styles-module-scss-module__p62fyG__contentWraper",
  "previewButton": "styles-module-scss-module__p62fyG__previewButton",
  "previewImage": "styles-module-scss-module__p62fyG__previewImage",
  "previewItem": "styles-module-scss-module__p62fyG__previewItem",
  "previewText": "styles-module-scss-module__p62fyG__previewText",
});
